var _circle, _path, _feDropShadow;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 15.5,
    r: 15,
    fill: "white",
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0547 13.1743C21.8561 12.9342 21.6076 12.7409 21.3267 12.6081C21.0458 12.4753 20.7394 12.4061 20.4291 12.4056H17.2061L17.6019 11.3878C17.7666 10.9422 17.8214 10.463 17.7617 9.99135C17.702 9.51969 17.5296 9.06965 17.2593 8.67984C16.9889 8.29002 16.6287 7.97207 16.2095 7.75324C15.7903 7.53442 15.3246 7.42125 14.8525 7.42346C14.7165 7.42375 14.5835 7.46352 14.4695 7.538C14.3554 7.61248 14.265 7.71851 14.2093 7.84339L12.1949 12.4056H10.534C9.97161 12.4056 9.43228 12.6306 9.03464 13.031C8.63699 13.4314 8.41359 13.9745 8.41359 14.5408V19.523C8.41359 20.0892 8.63699 20.6323 9.03464 21.0328C9.43228 21.4332 9.97161 21.6582 10.534 21.6582H19.5315C20.0275 21.658 20.5078 21.4827 20.8887 21.1628C21.2697 20.8429 21.5272 20.3986 21.6165 19.9073L22.5141 14.9251C22.5697 14.6172 22.5573 14.3008 22.4779 13.9982C22.3985 13.6957 22.254 13.4144 22.0547 13.1743ZM11.9476 20.2347H10.534C10.3465 20.2347 10.1667 20.1597 10.0342 20.0262C9.90164 19.8927 9.82718 19.7117 9.82718 19.523V14.5408C9.82718 14.352 9.90164 14.171 10.0342 14.0375C10.1667 13.9041 10.3465 13.8291 10.534 13.8291H11.9476V20.2347ZM21.1359 14.6689L20.2383 19.6511C20.2082 19.8169 20.1206 19.9665 19.9912 20.0734C19.8617 20.1803 19.6988 20.2374 19.5315 20.2347H13.3611V13.2668L15.2836 8.91099C15.4815 8.96908 15.6653 9.06786 15.8234 9.20108C15.9815 9.3343 16.1104 9.49907 16.202 9.685C16.2937 9.87092 16.3461 10.074 16.3559 10.2813C16.3657 10.4886 16.3327 10.6958 16.259 10.8896L15.8844 11.9074C15.8046 12.1225 15.7776 12.3539 15.8059 12.5818C15.8341 12.8097 15.9166 13.0273 16.0465 13.2161C16.1763 13.4049 16.3496 13.5592 16.5516 13.666C16.7535 13.7727 16.9781 13.8287 17.2061 13.8291H20.4291C20.5329 13.8289 20.6355 13.8518 20.7296 13.8961C20.8237 13.9403 20.9069 14.005 20.9733 14.0853C21.0414 14.1645 21.0913 14.2579 21.1194 14.3588C21.1475 14.4597 21.1531 14.5656 21.1359 14.6689Z",
    fill: "black"
  })), _feDropShadow || (_feDropShadow = /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 2,
    dy: 2,
    stdDeviation: 3,
    floodOpacity: 0.5
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhite);
export default __webpack_public_path__ + "static/media/white.802e38d4ddef9b8bb3d071102b592471.svg";
export { ForwardRef as ReactComponent };